import {
  ChevronLeft,
  Pencil02,
  SearchMd,
  XClose,
} from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

import Button from "@/components/forms/Button";
import Input from "@/components/forms/Input";

type GroupSettingsHeaderProps = {
  onBack: () => void;
  showSearch: boolean;
  onToggleSearch: () => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  canUpdate?: boolean;
  onEdit: () => void;
};

export default function GroupSettingsHeader({
  onBack,
  showSearch,
  onToggleSearch,
  searchQuery,
  onSearchChange,
  canUpdate = false,
  onEdit,
}: GroupSettingsHeaderProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <div className="flex items-center gap-3 border-b px-6 py-4">
      <Button
        color="tertiary-gray"
        square
        onClick={showSearch ? onToggleSearch : onBack}
      >
        {showSearch ? (
          <XClose className="size-5 text-gray-700" />
        ) : (
          <ChevronLeft className="size-5 text-gray-700 rtl:rotate-180" />
        )}
      </Button>
      {showSearch ? (
        <Input
          startIcon={<SearchMd className="size-5" />}
          placeholder={t("Search", { ns: "core.shared" })}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="min-w-0 flex-1"
          autoFocus
        />
      ) : (
        <span className="min-w-0 flex-1 text-lg font-semibold text-gray-900">
          {t("Settings", { ns: "core.shared" })}
        </span>
      )}
      {!showSearch && (
        <div className="flex items-center gap-1">
          <Button
            color="tertiary-gray"
            size="sm"
            square
            onClick={onToggleSearch}
          >
            <SearchMd className="size-5 text-gray-600" />
          </Button>
          {canUpdate && (
            <Button color="tertiary-gray" size="sm" square onClick={onEdit}>
              <Pencil02 className="size-5 text-gray-600" />
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
